import NotificationsNoneRoundedIcon from "@mui/icons-material/NotificationsNoneRounded";
import { SvgIconTypeMap } from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";

export type Alert = "high" | "medium" | "low";
type AlertData = {
  bg: any;
  color: any;
  Icon: OverridableComponent<SvgIconTypeMap<{}>>;
};

export const AlertMapper: Record<Alert, AlertData> = {
  low: { bg: "#d0f0c0", color: "#00695c", Icon: NotificationsNoneRoundedIcon },
  medium: {
    bg: "#fff176",
    color: "warning.main",
    Icon: ErrorOutlineRoundedIcon,
  },
  high: {
    bg: "error.light",
    color: "error.main",
    Icon: WarningAmberRoundedIcon,
  },
};

export const viewedMapper: Record<string, any> = {
  read: true,
  unRead: false,
  all: undefined,
};
